define([
  'vendor/jquery.validate.min.js',
  'app/modules/map',
  'vendor/countable.js',
  'app/control/uploader',
  'app/modules/language',
  'app/modules/forms',
  'app/modules/user',
  'app/modules/local_storage',
  'app/modules/utilities',
  'app/modules/employmentHistory',
  'app/modules/modals',
  'scriptjs'
], (
  jquery_validate,
  googleMap,
  Countable,
  Uploader,
  Language,
  Forms,
  User,
  LocalStorage,
  Util,
  EmploymentHistory,
  Modals,
  $script
) => {
  const Applications = function() {
    this.actionCreate = this.actionNew;
  };
  Applications.prototype.actionNew = Applications.prototype.actionEdit = function() {
    const mainForm = $('.job-application-form');
    Forms.bindSharedControls();
    LocalStorage.loadForm('job_application', mainForm.attr('action').split('/')[2]);
    const uplPhoto = new Uploader($('#application_user_photo'), { type: 'image', autoUpload: true });
    const uplResume = new Uploader($('#application_user_resume'), { type: 'file', autoUpload: true });
    $('[id^=custom_file_answers_]').each(function(_e) {
      new Uploader($(this), { type: 'attachment', autoUpload: true })
    });
    new EmploymentHistory({
      resourceName: 'job_application'
    });
    $('.add-language').on('click', e => {
      e.preventDefault();
      Language.add();
      // Forms.listsValidation();
    });
    $('.languages-list').on('click', '.remove-language', function(e) {
      e.preventDefault();
      Language.remove($(this));
      // Forms.listsValidation();
    });
    mainForm.on('submit', function(e) {
      e.preventDefault();
      if (!Modals.showDisclaimer()) {
        Forms.submitWithFiles($(this), 'job_application_');
      }
    });
    $('#job_application_email').on('input', function() {
      if (Util.validateEmail($(this).val())) Forms.checkEmailField($(this));
    });
    $('textarea[data-max-words]').each(function() {
      const txtArea = $(this);
      txtArea
        .parent()
        .find('.count_words')
        .html(txtArea.data('max-words'));
      Countable.live(this, function(ev) {
        const txtArea = $(this);
        const maxWord = $(this).data('max-words');
        if (ev.words > maxWord) {
          const arrVal =
            txtArea
              .val()
              .replace(/['";:,.?¿\-!¡]+/g, '')
              .match(/\S+/g) || [];
          txtArea.val(arrVal.slice(0, maxWord).join(' '));
        }
        const defWord = maxWord - ev.words;
        if (defWord < 0) {
          txtArea
            .parent()
            .find('.count_words')
            .css('display', 'none');
          txtArea
            .parent()
            .find('.warning_exceeding')
            .css('display', 'block');
        } else {
          txtArea
            .parent()
            .find('.count_words')
            .html(defWord)
            .css('display', 'block');
          txtArea
            .parent()
            .find('.warning_exceeding')
            .css('display', 'none');
        }
      });
    });
    $('.to-form').on('click', e => {
      e.preventDefault();
      $('.job-info-wrapper').hide();
      $('.with-loading-wrapper').show();
    });
    $('.switch-section .fa-angle-down').on('click', e => {
      e.preventDefault();
      $('.with-loading-wrapper').hide();
      $('.job-info-wrapper').show();
      $script.ready('google-maps', () => {
        const mapCanvas = document.getElementById('map');
        if (mapCanvas) {
          const lat = $(mapCanvas).attr('data-lat');
          const lon = $(mapCanvas).attr('data-lon');
          googleMap.init(mapCanvas, { zoom: 12, lat, lon }).then(map => {
            googleMap.addMarker(map, { lat, lon });
          });
        }
      });
    });
    $('.modal#sign-in-modal form#new_user').on('submit', e => {
      e.preventDefault();
      e.stopPropagation();
      User.signIn($(e.currentTarget), 'user_');
    });
    $('.modal-redirecting .btn-redirecting').on('click', e => {
      e.preventDefault();
      const externalUrl = $('.modal-redirecting').data('external-url');
      if (externalUrl && externalUrl != '') window.location = externalUrl;
    });
    Modals.initDisclaimer(() => {
      Forms.submitWithFiles(mainForm, 'job_application_');
    });
  };

  Applications.prototype.actionCreate = Applications.prototype.actionUpdate = function() {};

  return Applications;
});
